import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { clientsAPI } from '../utils/api';
import { ArrowLeft, Edit, Sparkles, Users } from 'lucide-react';
import ClientModal from '../components/modals/ClientModal';
import ContactModal from '../components/modals/ContactModal';
import DealModal from '../components/modals/DealModal';
import AIModalManager from '../components/AIModalManager';
import { OverviewTab, ContactsList, DealsList, ActivitiesList } from '../components/ClientDetailTabs';

var ClientDetail = function() {
  var p = useParams();
  var id = p.id;
  var nav = useNavigate();
  var s1 = useState(null); var client = s1[0]; var setClient = s1[1];
  var s2 = useState([]); var contacts = s2[0]; var setContacts = s2[1];
  var s3 = useState([]); var deals = s3[0]; var setDeals = s3[1];
  var s4 = useState([]); var activities = s4[0]; var setActivities = s4[1];
  var s5 = useState(true); var loading = s5[0]; var setLoading = s5[1];
  var s6 = useState('overview'); var tab = s6[0]; var setTab = s6[1];
  var s7 = useState(false); var editModal = s7[0]; var setEditModal = s7[1];
  var s8 = useState(false); var contactModal = s8[0]; var setContactModal = s8[1];
  var s9 = useState(false); var dealModal = s9[0]; var setDealModal = s9[1];
  var s10 = useState(null); var selContact = s10[0]; var setSelContact = s10[1];
  var s11 = useState(null); var aiModal = s11[0]; var setAiModal = s11[1];

  useEffect(function() { loadData(); }, [id]);

  var loadData = async function() {
    try {
      var r = await clientsAPI.getById(id);
      setClient(r.data);
      setContacts(r.data.contacts || []);
      setDeals(r.data.deals || []);
      setActivities(r.data.activities || []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  var fc = function(v) { return 'RM ' + (v / 1000).toFixed(0) + 'K'; };
  var fd = function(d) { return d ? new Date(d).toLocaleDateString() : 'N/A'; };

  if (loading) return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div></div>;
  if (!client) return <div className="text-center py-12"><p className="text-slate-600">Client not found</p></div>;

  var wt = 0;
  for (var i = 0; i < deals.length; i++) { if (deals[i].stage === 'Won') wt += deals[i].total_value || 0; }
  var ini = client.client_name ? client.client_name.charAt(0).toUpperCase() : '?';

  return (
    <div className="space-y-6" data-testid="client-detail-page">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button onClick={function() { nav('/clients'); }} className="text-slate-600 hover:text-slate-900" data-testid="back-to-clients"><ArrowLeft size={24} /></button>
          <div className="w-16 h-16 rounded-xl bg-primary/10 flex items-center justify-center text-primary font-bold text-2xl">{ini}</div>
          <div>
            <h1 className="text-3xl font-bold text-slate-900" data-testid="client-name">{client.client_name}</h1>
            <span className="text-slate-500">{client.organization_type || client.industry}</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={function() { setAiModal('enrich'); }} className="flex items-center gap-2 px-3 py-2 border border-primary text-primary rounded-lg hover:bg-primary/5 text-sm" data-testid="ai-enrich-btn"><Sparkles size={16} /> AI Enrich</button>
          <button onClick={function() { setAiModal('find'); }} className="flex items-center gap-2 px-3 py-2 border border-primary text-primary rounded-lg hover:bg-primary/5 text-sm" data-testid="ai-find-contacts-btn"><Users size={16} /> Find PICs</button>
          <button onClick={function() { setEditModal(true); }} className="flex items-center gap-2 px-4 py-2 border border-slate-300 rounded-lg text-slate-700 hover:bg-slate-50" data-testid="edit-client-btn"><Edit size={18} /> Edit</button>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div className="bg-white rounded-lg border border-slate-200 p-4"><p className="text-sm text-slate-600 mb-1">Total Deals</p><p className="text-2xl font-bold text-slate-900">{deals.length}</p></div>
        <div className="bg-white rounded-lg border border-slate-200 p-4"><p className="text-sm text-slate-600 mb-1">Won Value</p><p className="text-2xl font-bold text-green-600">{fc(wt)}</p></div>
        <div className="bg-white rounded-lg border border-slate-200 p-4"><p className="text-sm text-slate-600 mb-1">Contacts</p><p className="text-2xl font-bold text-slate-900">{contacts.length}</p></div>
        <div className="bg-white rounded-lg border border-slate-200 p-4"><p className="text-sm text-slate-600 mb-1">Activities</p><p className="text-2xl font-bold text-slate-900">{activities.length}</p></div>
      </div>

      <div className="bg-white rounded-lg border border-slate-200">
        <div className="border-b border-slate-200">
          <div className="flex gap-6 px-6">
            <button onClick={function() { setTab('overview'); }} className={'py-4 text-sm font-medium capitalize border-b-2 ' + (tab === 'overview' ? 'border-primary text-primary' : 'border-transparent text-slate-600')} data-testid="tab-overview">Overview</button>
            <button onClick={function() { setTab('contacts'); }} className={'py-4 text-sm font-medium capitalize border-b-2 ' + (tab === 'contacts' ? 'border-primary text-primary' : 'border-transparent text-slate-600')} data-testid="tab-contacts">Contacts</button>
            <button onClick={function() { setTab('deals'); }} className={'py-4 text-sm font-medium capitalize border-b-2 ' + (tab === 'deals' ? 'border-primary text-primary' : 'border-transparent text-slate-600')} data-testid="tab-deals">Deals</button>
            <button onClick={function() { setTab('activities'); }} className={'py-4 text-sm font-medium capitalize border-b-2 ' + (tab === 'activities' ? 'border-primary text-primary' : 'border-transparent text-slate-600')} data-testid="tab-activities">Activities</button>
          </div>
        </div>
        <div className="p-6">
          {tab === 'overview' && <OverviewTab client={client} />}
          {tab === 'contacts' && <ContactsList contacts={contacts} onAdd={function() { setSelContact(null); setContactModal(true); }} onEdit={function(c) { setSelContact(c); setContactModal(true); }} onFindPICs={function() { setAiModal('find'); }} />}
          {tab === 'deals' && <DealsList deals={deals} onAdd={function() { setDealModal(true); }} onClickDeal={function(dId) { nav('/deals/' + dId); }} fmtCurrency={fc} />}
          {tab === 'activities' && <ActivitiesList activities={activities} fmtDate={fd} />}
        </div>
      </div>

      {editModal && <ClientModal isOpen={editModal} onClose={function() { setEditModal(false); }} client={client} onSuccess={function() { loadData(); setEditModal(false); }} />}
      {contactModal && <ContactModal isOpen={contactModal} onClose={function() { setContactModal(false); setSelContact(null); }} contact={selContact} preSelectedClientId={id} onSuccess={function() { loadData(); setContactModal(false); setSelContact(null); }} />}
      {dealModal && <DealModal isOpen={dealModal} onClose={function() { setDealModal(false); }} onSuccess={function() { loadData(); setDealModal(false); }} />}
      <AIModalManager modalType={aiModal} client={client} onClose={function() { setAiModal(null); }} onDataChanged={loadData} />
    </div>
  );
};

export default ClientDetail;
